module.exports = __webpack_public_path__ + "static/pakmaya-ppd-sm-6b4838e23ec0ee9fd7ffbdfd0aef451f.jpg";